import { parseCookies } from 'nookies'
import { ReactNode, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { ModalLogin } from './modalLogin'

const publicRoutes = ['/sign-in', '/sign-up']

export function ProtectedLayout({ children }: { children: ReactNode }) {
  const [showModal, setShowModal] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const { 'reactAuth.token': token } = parseCookies()
    const isPublic = publicRoutes.includes(location.pathname)

    if (!token && !isPublic) {
      setShowModal(true)
    } else {
      setShowModal(false)
    }
  }, [location.pathname])

  return (
    <>
      {showModal && <ModalLogin />}
      {children}
    </>
  )
}
